export default "__VITE_ASSET__7HPoy5bi__"